import { render, staticRenderFns } from "./authHeader.vue?vue&type=template&id=4d63db70&scoped=true&"
import script from "./authHeader.vue?vue&type=script&lang=js&"
export * from "./authHeader.vue?vue&type=script&lang=js&"
import style0 from "./authHeader.vue?vue&type=style&index=0&id=4d63db70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d63db70",
  null
  
)

export default component.exports